// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../channels2022/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".div-badges[data-v-336efb28]{flex-basis:48px;width:48px;font-size:.5rem;line-height:.5rem;font-weight:700}@media(min-width: 768px){.div-badges[data-v-336efb28]{flex-basis:36px;width:36px}}.div-badges>span[data-v-336efb28]:not(:last-child){margin-right:.25rem}.div-info[data-v-336efb28]{flex-grow:1;flex-basis:128px;width:128px}@media(min-width: 1200px){.div-info[data-v-336efb28]{flex-basis:192px;width:192px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
